import { GET_MODIFIER_LIST } from './modifierTypes';
// import { Modifier } from '../../models/order/modifier';
export default {
    [GET_MODIFIER_LIST](state, data) {
        state.modifierData = data;
        state.modifierList = data.items;
        // let mod_arr = [];
        // for(let i = 0; i < data.items.length; i++) {
        //     mod_arr.push(new Modifier(data.items[i]));
        // }
        // state.modifierList = mod_arr;
    }
}
